import {LOAD} from "redux-storage";

export default (state = {loaded: false}, action) => {
    if (action.type === LOAD) {
        return {loaded: true};
    }
    return state;

}
